import script from "./VuetifyViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./VuetifyViewer.vue?vue&type=script&setup=true&lang=js"

import "./VuetifyViewer.vue?vue&type=style&index=0&id=1f1b2680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f1b2680"]])

export default __exports__